import { useState } from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import { Button, Dialog, InputText } from '../prime';
import styles from './header.module.scss';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  /** pedido de recargar las tarjetas */
  onRefresh: () => void;

  /** abre una tarjeta */
  onOpenId: (codigo: string) => void;
}

function HeaderComponent({ 
  storage, t,
  onRefresh, onOpenId,
} : IProps) {
  const [ search, setSearch ] = useState<string>('');
  const [ showWorkflow, setShowWorkflow ] = useState<boolean>(false);

  return <div className={styles["container"]}>
    <div style={{ display: 'flex', flexDirection: 'row', gap: 7, padding: 2 }}>
      <Button icon="fas fa-sitemap" label={t("Header.Btn.Workflow")} className="p-button-rounded p-button-info p-button-outlined" onClick={() => setShowWorkflow(true)} style={{ fontSize: 14 }} />
      <Button icon="fas fa-sync" label={t("Header.Btn.Refresh")} className="p-button-success" onClick={() => onRefresh()} />
    </div>
    <div style={{ marginLeft: 'auto' }}>
      <i className="fas fa-search" style={{ marginRight: 10 }}></i>
      <InputText 
        style={{ fontSize: 12 }} 
        value={search} 
        onChange={e => setSearch(e.target.value)} 
        onKeyUp={e => {
          if (e.key.toLowerCase() === 'enter') {
            if (search.length < 1) return false;
            onOpenId(search);
            return false;
          } else {
            return true;
          }
        }}
      />
    </div>
    
    <Dialog visible={showWorkflow} onHide={() => setShowWorkflow(false)} closeOnEscape dismissableMask header={t("Header.Workflow.Tooltip")} >
      <img src={`/images/operaciones/Operacion.Estado.Workflow.${t("@Id#Codigo")}.png`} alt={t("Header.Workflow.Tooltip")} />
    </Dialog>
  </div>;
}

export default connect((s:any) => ({ storage:s.main }))(HeaderComponent);